<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">{{ title }}</h3>
    <p class="modal-subtitle mb-0">
      {{ ApConfigLabel }}
      @if (FileName) {
        · {{ FileName }}
      }
      @if (isApplied) {
        · applied {{ appliedAt | date: 'M/d/yyyy h:mm a' }}
      } @else {
        · nothing has been saved yet
      }
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  @if (isApplied) {
    <div class="alert alert-success" role="alert">
      <strong>Run complete.</strong>
      <p class="mb-0 mt-1">
        {{ applicableCount }} applied · {{ skippedCount }} skipped ·
        {{ failedCount }} failed. Each applied vendor has a change-log note
        recording you as the actor.
      </p>
    </div>
  } @else if (applicableCount === 0) {
    <div class="alert alert-warning" role="alert">
      <strong>No changes to make.</strong>
      <p class="mb-0 mt-1">
        All {{ scanned }} AP vendors in this file are already Client Managed,
        already linked, or could not be found. Nothing will be written.
      </p>
    </div>
  }

  <dl class="cm-stats">
    <div class="cm-stat">
      <dt>Scanned</dt>
      <dd>{{ scanned }}</dd>
    </div>
    <div class="cm-stat cm-stat--apply">
      <dt>{{ isApplied ? 'Applied' : 'Will apply' }}</dt>
      <dd>{{ applicableCount }}</dd>
    </div>
    <div class="cm-stat cm-stat--skip">
      <dt>Skipped</dt>
      <dd>{{ skippedCount }}</dd>
    </div>
    <div class="cm-stat cm-stat--fail">
      <dt>Failed</dt>
      <dd>{{ failedCount }}</dd>
    </div>
  </dl>

  @if (!isApplied && (skippedCount > 0 || failedCount > 0)) {
    <ul class="vive-blue_list">
      @if (skippedCount > 0) {
        <li>
          Rows highlighted in
          <span class="cm-yellow fw-semibold">YELLOW</span> will be skipped —
          already Client Managed, or already linked. ({{ skippedCount }})
        </li>
      }
      @if (failedCount > 0) {
        <li>
          Rows highlighted in <span class="cm-red fw-semibold">RED</span> will
          fail — AP ID not found on this configuration, or duplicated in the
          file. ({{ failedCount }})
        </li>
      }
    </ul>

    <div class="action-row">
      @if (failedCount > 0) {
        <button
          type="button"
          class="btn btn-danger btn-sm"
          title="Remove all rows that will fail"
          (click)="removeFailedRows()"
        >
          Remove {{ failedCount }} Red Row{{ failedCount !== 1 ? 's' : '' }}
        </button>
      }
      @if (skippedCount > 0) {
        <button
          type="button"
          class="btn btn-warning btn-sm"
          title="Remove all rows that will be skipped"
          (click)="removeSkippedRows()"
        >
          Remove {{ skippedCount }} Yellow Row{{
            skippedCount !== 1 ? 's' : ''
          }}
        </button>
      }
    </div>
  }

  <div class="cm-table-scroll">
    <table class="cm-table">
      <thead>
        <tr>
          <th scope="col">AP ID</th>
          <th scope="col">Legal name</th>
          <th scope="col">DBA</th>
          <th scope="col">Outcome</th>
          <th scope="col">Reason</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row.line) {
          <tr
            [class.cm-row--failed]="isFailedRow(row)"
            [class.cm-row--skipped]="isSkippedRow(row)"
          >
            <td class="cm-num">{{ row.vendorKey }}</td>
            <td>{{ row.legalName || '—' }}</td>
            <td>{{ row.dba || '—' }}</td>
            <td>
              <span [class]="outcomeChipClass(row)">{{
                outcomeLabel(row)
              }}</span>
            </td>
            <td class="cm-reason">{{ row.reason || '—' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    @if (isApplied) {
      <button type="button" class="btn btn-outline" (click)="exportResults()">
        <i class="bi bi-download me-1"></i>
        Export results
      </button>
      <button type="button" class="btn btn-primary" (click)="close()">
        Close
      </button>
    } @else {
      @if (applicableCount === 0) {
        <small class="form-text me-auto">
          Nothing to apply — remove the yellow rows or pick a different file.
        </small>
      }
      <button type="button" class="btn btn-ghost" (click)="close()">
        Close
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="applicableCount === 0"
        (click)="apply()"
      >
        Apply to {{ applicableCount }} vendor{{
          applicableCount !== 1 ? 's' : ''
        }}
      </button>
    }
  </div>
</div>
